module.exports = __webpack_public_path__ + "static/media/Lecheria.63bc86d1.jpg";